// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Divider_black__7MDJT {
  background-color: #000000;
  border: 0.5px solid #000000;
}

.Divider_grey__Up0g9 {
  background-color: #E6E6E6;
  border: 0.5px solid #E6E6E6;
}

.Divider_no-margin__eHQ6i {
  padding: 0px;
  margin: 0px;
}

.Divider_vertical-left__ArMbC .Divider_vertical-grey__qnxYz {
  border-left: 1px solid #e6e6e6;
  padding-left: 5px;
}
.Divider_vertical-left__ArMbC .Divider_vertical-black__mvkcx {
  border-left: 1px solid black;
  padding-left: 5px;
}

.Divider_vertical-right__Z0NHT .Divider_vertical-grey__qnxYz {
  border-right: 1px solid #e6e6e6;
  padding-right: 5px;
}
.Divider_vertical-right__Z0NHT .Divider_vertical-black__mvkcx {
  border-right: 1px solid black;
  padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Divider/Divider.module.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,YAAA;EACA,WAAA;AAFJ;;AAMI;EACI,8BAAA;EACA,iBAAA;AAHR;AAMI;EACI,4BAAA;EACA,iBAAA;AAJR;;AASI;EACI,+BAAA;EACA,kBAAA;AANR;AASI;EACI,6BAAA;EACA,kBAAA;AAPR","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.black {\n    background-color: #000000;\n    border: 0.5px solid #000000;\n}\n\n.grey {\n    background-color: #E6E6E6;\n    border: 0.5px solid #E6E6E6;\n}\n\n.no-margin {\n    padding: 0px;\n    margin: 0px;\n}\n\n.vertical-left {\n    .vertical-grey {\n        border-left: 1px solid colors.$color-semantic-primary;\n        padding-left: 5px;\n    }\n\n    .vertical-black {\n        border-left: 1px solid black;\n        padding-left: 5px;\n    }\n}\n\n.vertical-right {\n    .vertical-grey {\n        border-right: 1px solid colors.$color-semantic-primary;\n        padding-right: 5px;\n    }\n\n    .vertical-black {\n        border-right: 1px solid black;\n        padding-right: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"black": `Divider_black__7MDJT`,
	"grey": `Divider_grey__Up0g9`,
	"no-margin": `Divider_no-margin__eHQ6i`,
	"vertical-left": `Divider_vertical-left__ArMbC`,
	"vertical-grey": `Divider_vertical-grey__qnxYz`,
	"vertical-black": `Divider_vertical-black__mvkcx`,
	"vertical-right": `Divider_vertical-right__Z0NHT`
};
export default ___CSS_LOADER_EXPORT___;
